import { render } from "./FamilyEmergencyMedicinePage.vue?vue&type=template&id=7cfca3be"
import script from "./FamilyEmergencyMedicinePage.vue?vue&type=script&lang=js"
export * from "./FamilyEmergencyMedicinePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__